<template><div><h1 id="fremddatenbank" tabindex="-1"><a class="header-anchor" href="#fremddatenbank"><span>Fremddatenbank</span></a></h1>
<p>Fremddatenbanken — Fremddatenbanken</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Eröffnet eine &quot;Fremddatenbank&quot; zum Einlesen von Fremdadressen. Bei einer &quot;Fremddatenbank&quot; handelt es sich nicht um eine neu angelegte Datenbank im klassischen Sinn sondern um Adressdaten, die innerhalb der bestehenden Datenbank, gesondert/abgegrenzt gespeichert werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Fremddatenbanken</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr</dt>
<dd>Nummer der Fremddatenbank, 3-stellig. Wird vom System fortlaufend vergeben, kann aber auch manuell eingegeben werden.</dd>
<dt>Beschreibung</dt>
<dd>Freier Text zur Beschreibung der Fremddatenbank</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


